import { jsx as r } from "react/jsx-runtime";
import { STATE_TO_ICON_COLOR_MAPPING as t } from "./index.es5737.js";
const n = ({ state: o }) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    "data-testid": "error-icon",
    role: "img",
    "aria-label": "error icon",
    children: /* @__PURE__ */ r(
      "path",
      {
        stroke: t[o],
        strokeLinecap: "round",
        d: "m12 11.5-7-7M5 11.5l7-7"
      }
    )
  }
);
export {
  n as ErrorIcon
};
//# sourceMappingURL=index.es5549.js.map
